import request from '../request'

export function fetchList(params) {
    return request({
        url: '/common-service/menu/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/common-service/menu/add',
        method: 'POST',
        data,
    })
}

export function edit(data) {
    return request({
        url: '/common-service/menu/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/common-service/menu/del',
        method: 'POST',
        data
    })
}